import { Outlet, useMatch } from "react-router";
import { Flex } from "@payping/web-components";
import { APP_ROUTES } from "@/utils";
import Menus from "./Menus";
import Header from "./Header";

const HomeLayout = () => {
  const match = useMatch(APP_ROUTES.home.orderDetail.url);

  return (
    <div className="tw:mx-auto tw:w-full tw:sm:my-16 tw:sm:max-w-120 tw:sm:rounded-md tw:sm:border tw:sm:border-solid tw:sm:border-color-border tw:lg:max-w-3xl">
      <Flex vertical className="tw:relative tw:h-full">
        {!match ? (
          <div className="tw:h-15">
            <Header />
          </div>
        ) : null}

        <div className="tw:grid tw:h-full tw:grid-cols-12 tw:overflow-auto">
          {!match ? (
            <div className="tw:col-span-4 tw:hidden tw:h-full tw:border-0 tw:border-l tw:border-solid tw:border-color-border tw:py-4! tw:lg:block">
              <Menus />
            </div>
          ) : null}

          {!match ? (
            <div className="tw:col-span-12 tw:h-full tw:w-full tw:overflow-auto tw:p-4! tw:max-lg:p-0 tw:lg:col-span-8">
              <Outlet />
            </div>
          ) : (
            <div className="tw:col-span-12 tw:h-full tw:w-full tw:overflow-auto">
              <Outlet />
            </div>
          )}
        </div>
      </Flex>
    </div>
  );
};

export default HomeLayout;
